import { render, staticRenderFns } from "./tabRefund.vue?vue&type=template&id=4c8315e2&scoped=true"
import script from "./tabRefund.vue?vue&type=script&lang=ts"
export * from "./tabRefund.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8315e2",
  null
  
)

export default component.exports